import { AccordionElement } from '@typedream/core';
import {
  deleteText,
  getLastChildPath,
  getNode,
  getPreviousPath,
  moveChildren,
  removeNodes,
  TNodeEntry,
  withoutNormalizing,
} from '@udecode/plate-core';
import { Path } from 'slate';
import { ELEMENT_ACCORDION_ITEM } from '../../../pluginKeys';
import { DreamEditor } from '../../../types';

export const normalizeAccordion = (
  editor: DreamEditor,
  entry: TNodeEntry<AccordionElement>,
) => {
  const [node, path] = entry;

  // remove empty accordion
  if (
    !node.children.length
    || !node.children.find((item) => item.type === ELEMENT_ACCORDION_ITEM)
  ) {
    removeNodes(editor, { at: path });
    return true;
  }

  const nextPath = Path.next(path);
  const nextNode = getNode(editor, nextPath);

  // Has an accordion afterwards, move children from next node to this node
  if (nextNode?.type === node.type) {
    withoutNormalizing(editor, () => {
      const lastChildPath = getLastChildPath(entry);
      const to = Path.next(lastChildPath);

      moveChildren(editor, {
        at: nextPath,
        to,
      });

      deleteText(editor, { at: nextPath });
    });

    return true;
  }

  const prevPath = getPreviousPath(path);
  if (!prevPath) return false;
  const prevNode = getNode(editor, prevPath);

  // Has an accordion before
  if (prevNode?.type === node.type) {
    editor.normalizeNode([prevNode, prevPath]);
  }

  return false;
};
